var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.08 5.37255L12.3492 0.212268C12.0892 0.0730339 11.797 0 11.5 0C11.203 0 10.9108 0.0730339 10.6508 0.212268L0.92 5.37469C0.642107 5.52206 0.410134 5.73903 0.248302 6.00295C0.0864714 6.26688 0.000719035 6.56807 0 6.87509V17.1249C0.000719035 17.4319 0.0864714 17.7331 0.248302 17.997C0.410134 18.261 0.642107 18.4779 0.92 18.6253L10.6508 23.7877C10.9108 23.927 11.203 24 11.5 24C11.797 24 12.0892 23.927 12.3492 23.7877L22.08 18.6253C22.3579 18.4779 22.5899 18.261 22.7517 17.997C22.9135 17.7331 22.9993 17.4319 23 17.1249V6.87616C22.9999 6.5686 22.9144 6.26673 22.7525 6.00219C22.5907 5.73765 22.3584 5.52018 22.08 5.37255ZM11.5 1.71266L20.3837 6.42818L17.0919 8.17507L8.20702 3.45955L11.5 1.71266ZM11.5 11.1437L2.61625 6.42818L6.36481 4.43909L15.2486 9.15461L11.5 11.1437ZM1.76923 7.92858L10.6154 12.6205V21.8147L1.76923 17.126V7.92858ZM21.2308 17.1217L12.3846 21.8147V12.6248L15.9231 10.7482V14.5732C15.9231 14.8006 16.0163 15.0186 16.1822 15.1794C16.3481 15.3402 16.5731 15.4305 16.8077 15.4305C17.0423 15.4305 17.2673 15.3402 17.4332 15.1794C17.5991 15.0186 17.6923 14.8006 17.6923 14.5732V9.80943L21.2308 7.92858V17.1206V17.1217Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestInactive);
export default __webpack_public_path__ + "static/media/requestInactive.b013a5fe5279816ea4ce0fb4165661dd.svg";
export { ForwardRef as ReactComponent };